import { useState } from "react";
import CustomModal from "../components/CustomModal";
import ContentOverlay from "../components/content_overlay";
import "./posters.css";

const posters = [
  { title: "Endemic Flora of Andaman and Nicobar", src: "posters/1.jpg" },
  { title: "Aquatic Plants of Western Ghats", src: "posters/2.jpg" },
  { title: "Endemic Flora of Arid Zone of India", src: "posters/3.jpg" },
  { title: "Endemic Flora of Deccan", src: "posters/4.jpg" },
  {
    title: "Plants of Medicinal Importance - Dhanvantari Vana",
    src: "posters/5.jpg",
  },
  { title: "Endemic Flora of Eastern Western Ghats", src: "posters/6.jpg" },
  {
    title: "Endemic Flora of Eastern Himalaya of India",
    src: "posters/7.jpg",
  },
  { title: "Endemic Plants of Central India", src: "posters/8.jpg" },
  { title: "Endemic Plants of Northern Western Ghats", src: "posters/9.jpg" },
  { title: "Scientific Importance of Havana", src: "posters/10.jpg" },
  { title: "Flora of Indo-Gangetic Plain", src: "posters/11.jpg" },
  {
    title: "Scientific Significance of Navagraha Havan",
    src: "posters/12.jpg",
  },
  { title: "Endemic Flora of Assam", src: "posters/13.jpg" },
  { title: "Endemic Flora of Southern Western Ghats", src: "posters/14.jpg" },
  {
    title: "Trees of Kerala",
    src: [
      "posters/trees_of_kerala/1.jpg",
      "posters/trees_of_kerala/2.jpg",
      "posters/trees_of_kerala/3.jpg",
      "posters/trees_of_kerala/4.jpg",
      "posters/trees_of_kerala/5.jpg",
      "posters/trees_of_kerala/6.jpg",
      "posters/trees_of_kerala/7.jpg",
      "posters/trees_of_kerala/8.jpg",
      "posters/trees_of_kerala/9.jpg",
      "posters/trees_of_kerala/10.jpg",
      "posters/trees_of_kerala/11.jpg",
      "posters/trees_of_kerala/12.jpg",
      "posters/trees_of_kerala/13.jpg",
      "posters/trees_of_kerala/14.jpg",
      "posters/trees_of_kerala/15.jpg",
    ],
  },
  {
    title: "Shrubs of Kerala",
    src: [
      "posters/shrubs_of_kerala/16.jpg",
      "posters/shrubs_of_kerala/17.jpg",
      "posters/shrubs_of_kerala/18.jpg",
      "posters/shrubs_of_kerala/19.jpg",
      "posters/shrubs_of_kerala/20.jpg",
      "posters/shrubs_of_kerala/21.jpg",
      "posters/shrubs_of_kerala/22.jpg",
      "posters/shrubs_of_kerala/23.jpg",
      "posters/shrubs_of_kerala/24.jpg",
      "posters/shrubs_of_kerala/25.jpg",
      "posters/shrubs_of_kerala/26.jpg",
      "posters/shrubs_of_kerala/27.jpg",
    ],
  },
  {
    title: "Herbs of Kerala",
    src: [
      "posters/herbs_of_kerala/28.jpg",
      "posters/herbs_of_kerala/29.jpg",
      "posters/herbs_of_kerala/30.jpg",
      "posters/herbs_of_kerala/31.jpg",
      "posters/herbs_of_kerala/32.jpg",
      "posters/herbs_of_kerala/33.jpg",
      "posters/herbs_of_kerala/34.jpg",
      "posters/herbs_of_kerala/35.jpg",
      "posters/herbs_of_kerala/36.jpg",
      "posters/herbs_of_kerala/37.jpg",
      "posters/herbs_of_kerala/38.jpg",
      "posters/herbs_of_kerala/39.jpg",
      "posters/herbs_of_kerala/40.jpg",
      "posters/herbs_of_kerala/41.jpg",
      "posters/herbs_of_kerala/42.jpg",
      "posters/herbs_of_kerala/43.jpg",
      "posters/herbs_of_kerala/44.jpg",
      "posters/herbs_of_kerala/45.jpg",
      "posters/herbs_of_kerala/46.jpg",
      "posters/herbs_of_kerala/47.jpg",
      "posters/herbs_of_kerala/48.jpg",
      "posters/herbs_of_kerala/49.jpg",
      "posters/herbs_of_kerala/50.jpg",
      "posters/herbs_of_kerala/51.jpg",
      "posters/herbs_of_kerala/52.jpg",
      "posters/herbs_of_kerala/53.jpg",
      "posters/herbs_of_kerala/54.jpg",
    ],
  },
];

function PosterPage() {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (src) => {
    setSelectedImage(src);
  };

  return (
    <>
      <ContentOverlay
        text_content={
          <div className="container text-center">
            <h2>Posters</h2>
            <div className="row justify-content-center mt-4">
              {posters.map((poster, index) => (
                <div key={index} className="col-md-5 col-lg-4 m-2">
                  <button
                    className="btn btn-poster w-100"
                    onClick={() => handleImageClick(poster.src)}
                    style={{
                      borderRadius: "20px",
                      backgroundColor: "#FFF2AF",
                      mixBlendMode: "multiply",
                      whiteSpace: "normal",
                    }}
                  >
                    {poster.title}
                  </button>
                </div>
              ))}
            </div>
          </div>
        }
      />
      {selectedImage && (
        <CustomModal
          show={true}
          onClose={() => setSelectedImage(null)}
          content={selectedImage} // If it’s an array, pass multiple images
        />
      )}
    </>
  );
}

export default PosterPage;
